/**
 * Создает новый контроллер, прерывает предыдущий
 */
export const getAbortControllerRecreater = () => {
    let controller: AbortController | null = null;

    return () => {
        controller && controller.abort();
        controller = new AbortController();
        return controller;
    };
};
